<template>
    <div class="signup-quote-panel">
        <strong>Cost estimate:</strong>
        Setup ${{ formatPrice(quote.setup) }}
        &middot;
        Monthly ${{ formatPrice(quote.monthly) }}
        <small v-if="quote.additionalCount > 0" class="signup-choice__meta">
            includes {{ quote.additionalCount }} additional MLS &times; ${{ formatPrice(perAdditionalFee) }}/mo
        </small>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import useState from '@/composables/useState';

const { state, quote } = useState();

const perAdditionalFee = computed(() => {
    const plan = state.catalog.plans.find((p) => p.code === state.form.planCode);
    return parseFloat(plan?.additionalAssociationMonthly || 0);
});

const formatPrice = (n) => parseFloat(n || 0).toFixed(2);
</script>
